import { createRoot } from "react-dom/client";
import { Scene } from "./Scene";

function mount() {
  const container = document.getElementById("predictive-arc-hero");
  if (container) {
    const root = createRoot(container);
    root.render(<Scene />);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
